import script from "./brandColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./brandColumn.vue?vue&type=script&setup=true&lang=js"

import "./brandColumn.vue?vue&type=style&index=0&id=1e9ba93e&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9ba93e"]])

export default __exports__